import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Bolet amb capell grisenc amb esquames nombroses i petites de color negre. Mesura fins a 9 cm de diàmetre, pla, ondulat i amb els marges aixecats amb l’edat. Les làmines són blanques, amples, fràgils i atapeïdes, amb l’aresta un poc tacada de punts de color negre. El peu és llarg i rabassut, grisenc, amb fibril·les esquamoses color grisenc. Les espores són blanques en massa, el·lipsoïdals, de 7-8 x 4-5 micres.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      